import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { StoryHero } from '../components/story/StoryHero';
import { StoryPullQuote } from '../components/story/StoryPullQuote';
import { StoryCredentials } from '../components/story/StoryCredentials';
import { StoryTestimonials } from '../components/story/StoryTestimonials';
import { StoryOrigin } from '../components/story/StoryOrigin';
import { StoryCta } from '../components/story/StoryCta';
export function MyStoryPage() {
  return <div className="min-h-screen flex flex-col w-full bg-white font-body" data-id="element-499" data-mp="p0j8mf8ywpf">
      <Navigation data-id="element-500" data-mp="eo9ztn7d7stx" />
      <main className="flex-grow" data-id="element-501" data-mp="eos4n883ffdg">
        <StoryHero data-id="element-502" data-mp="ekulimlimntk" />
        <StoryPullQuote data-id="element-503" data-mp="9nmar72p5m2c" />
        <StoryCredentials data-id="element-504" data-mp="9n2pphhr2hk3" />
        <StoryTestimonials data-id="element-505" data-mp="9mt0vx8fygfz" />
        <StoryOrigin data-id="element-506" data-mp="1q2drgmqhd4vt" />
        <StoryCta data-id="element-507" data-mp="1q1ku2cdevrqc" />
      </main>
      <Footer data-id="element-508" data-mp="1q0sw4uwcdhww" />
    </div>;
}